import { PageBlueprint } from '@backstage/frontend-plugin-api';
import {
  compatWrapper,
  convertLegacyPlugin,
  convertLegacyRouteRef,
} from '@backstage/core-compat-api';
import {
  explorePlugin as legacyExplorePlugin,
  exploreRouteRef,
} from '@backstage-community/plugin-explore';
import ExploreIcon from '@material-ui/icons/Explore';

const explorePage = PageBlueprint.make({
  params: {
    path: '/explore',
    title: 'Explore',
    icon: <ExploreIcon />,
    // Bind the *plugin's* root route ref rather than a locally created one.
    // Since explore 1.0.1 (the MUI -> BUI migration) ExploreLayout resolves
    // exploreRouteRef through useRouteRef to build absolute hrefs for its
    // PluginHeader tabs, so if nothing mounts that ref the page dies with
    // "No path for routeRef{id=explore.explore,legacyId=explore}".
    // convertLegacyRouteRef mutates and returns the same object (and is
    // idempotent), so the ref ExploreLayout reads is the one bound here.
    routeRef: convertLegacyRouteRef(exploreRouteRef),
    loader: async () => {
      const { ExplorePage } = await import('./ExplorePage');
      // Explore is a legacy-frontend plugin; wrap so its legacy APIs resolve.
      return compatWrapper(<ExplorePage />);
    },
  },
});

// Convert the whole legacy plugin (not just the page) so its api factory —
// exploreApiRef (the ExploreClient that calls the explore-backend) — is
// registered in the new frontend system; ToolExplorerContent needs it at
// runtime. compatWrapper alone renders the page but does not bring the apis.
// The version skew that used to *force* this path is gone: explore 1.0.1 now
// depends on frontend-plugin-api ^0.17.2 / catalog-react ^3.1.0 and resolves to
// the app's own instances, so its native `/alpha` plugin would work. We stay on
// the legacy + convertLegacyPlugin path because the custom ExplorePage below
// composes ExploreLayout by hand (Domains/Systems only, own tab content);
// switching to `/alpha` means overriding `page:explore` instead.
export const explorePlugin = convertLegacyPlugin(legacyExplorePlugin, {
  extensions: [explorePage],
});